<template>
  <div>
    <p v-if="authorList.length">
      <strong>Byline: </strong>
      <span v-for="(author, index) in authorList" :key="index">{{ author }}</span>
    </p>
    <p v-else-if="resolvedXmlByline">
      <strong>Byline: </strong><span>{{ resolvedXmlByline }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'IssueArticleByline',
  props: {
    /** Document author names (UDF); must be an array — not raw XML. */
    authors: {
      type: [Array, String],
      default: () => []
    },
    /** Parsed XML byline from the parent (issue article details). */
    xmlByline: {
      type: String,
      default: ''
    }
  },
  computed: {
    authorList () {
      return Array.isArray(this.authors) ? this.authors : []
    },
    resolvedXmlByline () {
      if (this.xmlByline) return this.xmlByline
      const fromStore = this.$store.state.store_xml_byline
      return typeof fromStore === 'string' && fromStore ? fromStore : ''
    }
  }
}
</script>

<style scoped>

</style>
